'use client';

var DEFAULT_STYLE_OTPIONS = {
    displayAlign: 'right',
    isRounded: false,
    button: {
        size: 'md',
        type: 'default',
        outline: 'none',
        isIcon: true
    },
    customPadding: '',
    responsiveButton: {
        type: 'default'
    }
};
var DEFAULT_TEXT_OPTIONS = {
    closeText: 'Close'
};

export { DEFAULT_STYLE_OTPIONS, DEFAULT_TEXT_OPTIONS };
//# sourceMappingURL=constants.js.map
